module.exports = __webpack_public_path__ + "img/mypic.381d104.webp";